import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getPagedAuthoringUsers = api(
    ({ searchTerm = "", skip = 0, take = 20, orderStmt = ["displayName"] } = {}) =>
        query(
            gql`
                query GetPagedAuthoringUsers($searchTerm: String, $skip: Int, $take: Int, $orderStmt: [String]) {
                    getPagedAuthoringUsers(
                        searchTerm: $searchTerm

                        skip: $skip
                        take: $take
                        orderStmt: $orderStmt
                    ) {
                        totalCount
                        pageInfo {
                            endCursor
                            hasNextPage
                            hasPreviousPage
                            startCursor
                        }
                        edges {
                            node {
                                UserName
                                id: UserId
                                metadata {
                                    displayName
                                    email
                                    company
                                    jobTitle
                                    roles
                                }
                                authoringProjects {
                                    projects {
                                        name
                                    }
                                    total
                                }
                            }
                            cursor
                        }
                    }
                }
            `,
            { searchTerm, skip, take, orderStmt },
            { returns: "getPagedAuthoringUsers", fetchPolicy: "network-only" }
        )
)
